import React, { Component } from "react";

export default class KheshtiRug extends Component {
  render() {
    let display = this.props.show ? "" : "none";
    return (
      <div style={{ display: display }}>
        <div className="main-carpet-kheshti">
          <div className="background-carpet">
            <img
              src={
                this.props.background && this.props.background.image
                  ? this.props.background.image
                  : "/static/img/background.png"
              }
              onDragStart={(e) => e.preventDefault()}
              alt="Background"
            />
          </div>
          <div className="flex-container">
            <img
              alt="Tile"
              className="flex-item"
              onDragStart={(e) => e.preventDefault()}
              src={
                this.props.tile && this.props.tile.image
                  ? this.props.tile.image
                  : "/static/img/tile.png"
              }
            />
          </div>
        </div>
      </div>
    );
  }
}
